{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              89.20710820839486,
              21.368412345943725
            ],
            [
              67.9526480834466,
              23.919732819341448
            ],
            [
              73.1683711294248,
              10.890774411999331
            ],
            [
              46.13125420798232,
              0.5780552517122288
            ],
            [
              45.43452433006246,
              -10.995868136428285
            ],
            [
              83.6309603332075,
              4.870673639773358
            ],
            [
              89.20710820839486,
              21.368412345943725
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}